export default "__VITE_ASSET__b3e5d67f__"